import { useCallback } from 'react';
import { FormDataType } from '@tw/tw-component-library';
import {
  FormSchemaConfig,
  ValidationError,
  EnhancedSection,
  EnhancedGroupedSection,
  ValidationResult,
  isEnhancedSection,
} from '../../types/form/schema.types';
import { validateField } from '../../utils/fieldProcessing';

export const useFormValidation = () => {
  const validateSection = useCallback(
    (schema: FormSchemaConfig, data: FormDataType): ValidationResult => {
      const errors: ValidationError[] = [];

      const processSection = (
        section: EnhancedSection | EnhancedGroupedSection
      ) => {
        if (isEnhancedSection(section) && section.fields) {
          section.fields.forEach((field) => {
            // Match the validateField signature
            const validationResult = validateField(
              field.name,
              data[field.name],
              field.validation,
              data
            );

            if (!validationResult.isValid) {
              errors.push(...validationResult.errors);
            }
          });
        }

        if ('sections' in section && section.sections) {
          section.sections.forEach(processSection);
        }
      };

      schema.sections.forEach(processSection);

      return {
        isValid: errors.length === 0,
        errors,
      };
    },
    []
  );

  return { validateSection };
};
